import * as t from 'io-ts';
import { id, meta, links } from '../..';
import { withFallback } from 'io-ts-types/withFallback';

const template = t.type({
  logo: t.union([t.string, t.null]),
  display_entity_item: t.boolean,
  display_score: t.boolean,
  display_rocc_score: withFallback(t.boolean, false),
  display_score_range_labels: t.boolean,
  display_score_result_of_pages: withFallback(t.boolean, true),
  average_weighted_score_calculation: withFallback(t.boolean, false),
  display_description: t.boolean,
  display_negative_answers: withFallback(t.boolean, true),
  display_issues: withFallback(t.boolean, true),
  exclude_questions_type_instruction: t.boolean,
  exclude_questions_not_responded: t.boolean,
  score_range_labels: t.array(t.type({
    min: t.string,
    max: t.string,
    label: withFallback(t.string, ''),
    color: t.string,
  })),
});

const data = t.type({
  title: t.string,
  template,
  organization: t.union([t.number, t.undefined]),
  checklist: t.union([t.number, t.null, t.undefined]),
  isDefault: t.union([t.number, t.undefined]),
});

export const recordCodec = t.type({
  id,
  data,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  links,
  meta: t.intersection([
    meta,
    t.type({
      default: t.type({
        data,
      }),
    }),
  ]),
});

export const formCodec = t.type({
  title: t.string,
  template,
  checklist: t.union([t.number, t.null]),
  isDefault: t.number,
});
